import React from 'react';
import PropTypes from 'prop-types';
import PublicationItem from '@components/PublicationItem';
import ScrollToNext from '@components/ScrollToNext';
import publicationItems from './publication-items';

import './style.scss';

const PublicationPage = (props, context) => {
  const {
    theme: { colorPrimary, colorAlternate, textAlternate, bgPrimary }
  } = context;

  return (
    <div className="publication-page" style={{ backgroundColor: bgPrimary }}>
      <div className="content-grid">
        <h1 style={{ color: colorPrimary }}>Publications and Talks</h1>
        <div className="publication-wrapper">
          <style jsx="true">
            {`
              .publication-item {
                background-color: ${colorPrimary};
                color: ${textAlternate};
              }
              .publication-item a {
                color: ${textAlternate};
              }
              .publication-item__links a:hover {
                border-bottom: 2px solid ${colorAlternate};
              }
            `}
          </style>
          {/* <PublicationItem /> */}
          {publicationItems.map((item, i) => (
            <PublicationItem {...item} key={i}/>
          ))}
        </div>
      </div>
      <ScrollToNext pageSelector=".project-page" />
    </div>
  );
};

PublicationPage.contextTypes = {
  theme: PropTypes.any
};

export default PublicationPage;



// WEBPACK FOOTER //
// ./src/pages/PublicationPage/PublicationPage.js